import type React from "react";
import { useGoals } from "@/hooks/useGoals";
import GoalProgressBar from "./components/GoalProgressBar";
import WeeklySummary from "./components/WeeklySummary";

const ProgressTrackerPage: React.FC = () => {
	const { goals, loading, error } = useGoals();

	if (loading) {
		return (
			<div className="container mx-auto px-4 py-8">
				<p className="text-center text-gray-500">読み込み中...</p>
			</div>
		);
	}

	if (error) {
		return (
			<div className="container mx-auto px-4 py-8">
				<p className="text-center text-red-500">
					エラーが発生しました: {error.message}
				</p>
			</div>
		);
	}

	return (
		<div className="container mx-auto px-4 py-8">
			<h1 className="text-3xl font-bold mb-6">進捗トラッカー</h1>

			<div className="bg-white p-6 rounded shadow mb-6">
				<h2 className="text-xl font-semibold mb-4">目標の進捗状況</h2>
				{goals.length === 0 ? (
					<p className="text-gray-500">目標が設定されていません</p>
				) : (
					goals.map((goal) => <GoalProgressBar key={goal.id} goal={goal} />)
				)}
			</div>

			{goals.length > 0 && (
				<div className="bg-white p-6 rounded shadow">
					<h2 className="text-xl font-semibold mb-4">週次サマリー</h2>
					<WeeklySummary goals={goals} />
				</div>
			)}
		</div>
	);
};

export default ProgressTrackerPage;
